import { Injectable, signal } from '@angular/core';

/** docs/design/16_workflow_engine.md §14.3 — one Validation step that failed during the current user's own
 * action. Both texts are the admin's own (never machine-translated); the banner shows the viewer's language. */
export interface WorkflowValidationNotice {
  stepName: string;
  messageEn: string;
  messageAr: string;
}

/** Holds the Validation failure message(s) the API just reported for the user's OWN action (via the
 * `X-Workflow-Validation-Failures` response header - see `workflowValidationInterceptor`), for
 * `WorkflowNoticeBannerComponent` to show until dismissed. A new action replaces the previous notice. */
@Injectable({ providedIn: 'root' })
export class WorkflowNoticeService {
  readonly notices = signal<WorkflowValidationNotice[]>([]);

  /** docs/design/16_workflow_engine.md §18.17 - the stable code (WRITE_STEP_FAILED, MAPPED_RECORD_NOT_FOUND, ...) of a
   * workflow write step that failed during the user's own action; the banner maps it through its own i18n. */
  readonly errorCode = signal<string | null>(null);

  showError(code: string): void {
    this.errorCode.set(code);
  }

  show(notices: WorkflowValidationNotice[]): void {
    this.notices.set(notices);
  }

  dismiss(): void {
    this.notices.set([]);
    this.errorCode.set(null);
  }
}
